module.exports = {
  async signIn(params) {
    const response = await this.post(`${this.url}/auth/sign_in`, params);
    this.saveSession(response);
    return response.data;
  },
  async signOut() {
    const headers = this.buildSessionHeaders();
    this.removeSession();
    const response = await this.delete(`${this.url}/auth/sign_out`, headers);
    return response.data;
  },
  async signUp(params) {
    const response = await this.post(`${this.url}/auth`, params);
    this.saveSession(response);
    return response.data;
  },
  async validateToken() {
    const headers = this.buildSessionHeaders();
    const response = await this.get(`${this.url}/auth/validate_token`, null, headers);
    this.saveSession(response);
    return response.data;
  },
};



// WEBPACK FOOTER //
// ./src/libs/api_client/modules/sessions_api.js